
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4fb4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4fb4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bCIFA", function(module, exports) {

$parcel$export(module.exports, "register", () => $8765e4c924822d27$export$6503ec6e8aabbaf, (v) => $8765e4c924822d27$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $8765e4c924822d27$export$f7ad0328861e2f03, (v) => $8765e4c924822d27$export$f7ad0328861e2f03 = v);
var $8765e4c924822d27$export$6503ec6e8aabbaf;
var $8765e4c924822d27$export$f7ad0328861e2f03;
"use strict";
var $8765e4c924822d27$var$mapping = new Map();
function $8765e4c924822d27$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8765e4c924822d27$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8765e4c924822d27$var$resolve(id) {
    var resolved = $8765e4c924822d27$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8765e4c924822d27$export$6503ec6e8aabbaf = $8765e4c924822d27$var$register;
$8765e4c924822d27$export$f7ad0328861e2f03 = $8765e4c924822d27$var$resolve;

});

var $64513cb81e22140d$exports = {};

(parcelRequire("bCIFA")).register(new URL("", import.meta.url).toString(), JSON.parse('["did5v","index.e79cbf34.js","jOf8h","facebook.6589cf95.png","jaFov","twitter.aba9a904.png","aAKeD","instagram.13f85021.png","dDw6O","github.d387460f.png","81Oy9","robot.f75fe62b.png","iZVJy","viseye-figure.e000980f.png","ckMH8","eye-outline.0689687f.png","hVdHE","eye-outline-crossed.117cf0e3.png","8Sc6e","user-profile.2c299575.png","kP9hh","Lingo.23dbd94f.js","6lN2S","rocketGame.1c49d56c.js","6Y3Jd","MainScreen.d249954d.png","8L80X","LevelSelector.23eec434.png","lO4fj","DifferentThemes.f7dbaf2b.png","kFwPl","FlowerFire.68fe8c2d.png"]'));


//# sourceMappingURL=index.runtime.56586e53.js.map
